import React, { Fragment, useEffect, useState } from "react";
import DataTable from "../../../Common/Components/DataTable";
import {
  GetData,
  DeleteData,
  EditData,
  DataSearch,
} from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import { Helmet } from "react-helmet";
import CustomModal from "../../../Common/Components/Modal/CustomModal";
import CommonFrom from "../../../Common/Components/Form";
import { input } from "./Create";
function List() {
  const initialState = {
    loading: false,
    data: {
      data: null,
      current_page: null,
    },
    modal: false,
  };
  const [state, setstate] = useState(initialState);

  useEffect(() => {
    Handler();
  }, []);

  const Handler = (pageNumber = 1, limit, index) => {
    setstate({ ...state, loading: true });
    GetData(pageNumber, limit, index).then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };

  const HandlerDelete = data => {
    setstate({ ...state, loading: true });
    DeleteData(data).then(() => {
      GetData().then(result => {
        setstate({
          loading: false,
          data: result,
        });
      });
    });
  };

  const HandlerEdit = data => {
    setstate({ ...state, loading: true });
    EditData({ ...data, tag_id: state.data.data[state.modal - 1].id }).then(
      () => {
        GetData().then(result => {
          setstate({
            loading: false,
            data: result,
          });
        });
      }
    );
  };
  const HandlerSearch = data => {
    setstate({ ...state, loading: true });
    DataSearch({ name: data }).then(data => {
      setstate({
        loading: false,
        data: data,
      });
    });
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست تگ ها</title>
      </Helmet>

      <DataTable
        loading={state.loading}
        heads={[
          {
            title: "عنوان تگ",
            key: "name",
          },
          {
            title: "کلمات کلیدی سئو",
            key: "seo",
            keyName: "seoKeyword",
          },
          {
            title: "توضیحات سئو",
            key: "seo",
            keyName: "seoDescription",
          },
          {
            title: "اخرین بروز رسانی",
            key: "updated_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty="تگی  ثبت نشده"
        list={state.data && state.data.data}
        data={state.data}
        function={Handler}
        search={HandlerSearch}
        currentPage={state.data && state.data.current_page}
        header=" لیست تگ ها"
        textbtn="ایجاد تگ"
        linkbtn="/Admin/Tag/Create"
        links={[
          {
            function: selected => {
              HandlerDelete({ tag_id: selected });
            },
            color: "danger",
            size: "col-md-2",
            html: "حذف",
            multi: true,
            type: "delete",
          },
          {
            function: selected => {
              setstate({ ...state, modal: selected[0] });
            },
            color: "info",
            type: "key",
            size: "col-md-2",
            html: "ویرایش",
            type: "delete",
            main: true,
          },
        ]}
      />
      <CustomModal
        show={state.modal}
        handleClose={() => {
          setstate({ ...state, modal: false });
        }}
        header={"ویرایش تگ"}
      >
        <CommonFrom
          edit={true}
          loading={state.loading}
          form={input}
          btnName={"ثبت اطلاعات تگ"}
          value={
            state.data && state.data.data && state.data.data[state.modal - 1]
          }
          submit={HandlerEdit}
        />
      </CustomModal>
    </Fragment>
  );
}

export default List;
